import { availableGenders } from '@common/Product/constants/gender';
import { saveState } from '@helpers/localStorage';
import {
    FETCH_FAVORITES_REQUEST,
    FETCH_FAVORITES_SUCCESS,
    FETCH_FAVORITES_FAILURE,
    ADD_FAVORITES_REQUEST,
    ADD_FAVORITES_SUCCESS,
    ADD_FAVORITES_FAILURE,
    DELETE_FAVORITES_REQUEST,
    DELETE_FAVORITES_SUCCESS,
    DELETE_FAVORITES_FAILURE,
    SET_FAVORITE_BRAND,
    ADD_FAVORITE_BRAND,
    REMOVE_FAVORITE_BRAND,
    SET_BRAND_FAVORITES,
    ADD_TO_FAVORITES_QUEUE,
    REMOVE_FROM_FAVORITES_QUEUE,
    DROP_FAVORITES,
    UPDATE_FAVORITES_VARIANTS_IDS,
    ADD_FAVORITE_VARIANT_ID
} from '../actions/actionsConstants';
import { FAVORITE_PRODUCTS_CACHE_NAME } from '../constants/cache';

const getDefaultBrandsState = () => availableGenders.reduce((draftState, gender) => {
    draftState[gender] = [];

    return draftState;
}, {});

const initialState = {
    products: [],
    variantIds: [],
    requestQueue: [],
    brands: getDefaultBrandsState(),
    isFetched: false
};

export default function favorites(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case FETCH_FAVORITES_REQUEST:
            return { ...state, products: [], isFetched: false };
        case FETCH_FAVORITES_SUCCESS:
            return { ...state, products: payload, isFetched: true };
        case FETCH_FAVORITES_FAILURE:
            return state;
        case ADD_FAVORITES_REQUEST:
            return state;
        case ADD_FAVORITES_SUCCESS:
            if (payload) {
                saveState(FAVORITE_PRODUCTS_CACHE_NAME, [payload, ...state.products]);
                return { ...state, products: [payload, ...state.products] };
            }

            return state;
        case ADD_FAVORITES_FAILURE:
            return state;
        case DELETE_FAVORITES_REQUEST:
            return state;

        case DELETE_FAVORITES_SUCCESS: {
            if (typeof payload === 'undefined') {
                return { ...state, products: [] };
            }

            let products = [];
            const { products: currentProducts } = state;
            const variantIds = typeof action.payload === 'number' ? [action.payload] : action.payload;

            if (currentProducts.length > 0) {
                products = currentProducts.filter((product) => {
                    const variantId = product.variant_id || product.variants[0].id;
                    return !(variantIds.indexOf(variantId) >= 0);
                });
            }

            saveState(FAVORITE_PRODUCTS_CACHE_NAME, products);
            return { ...state, products };
        }

        case DELETE_FAVORITES_FAILURE:
            return state;

        case SET_FAVORITE_BRAND: {
            return {
                ...state,
                brands: {
                    ...state.brands,
                    [payload.gender]: payload.brands
                }
            };
        }

        case ADD_FAVORITE_BRAND: {
            const { brand } = payload;
            const { gender } = brand;
            const brandsNew = { ...state.brands };

            if (typeof brandsNew[gender] === 'undefined') {
                brandsNew[gender] = [];
            }

            return {
                ...state,
                brands: {
                    ...brandsNew,
                    [gender]: [...brandsNew[gender], brand]
                }
            };
        }

        case REMOVE_FAVORITE_BRAND: {
            if (typeof payload === 'undefined') {
                return state;
            }

            if (typeof state.brands === 'undefined') {
                return {
                    ...state,
                    brands: getDefaultBrandsState()
                };
            }

            let newBrands = [];

            if (state.brands[payload.brand.gender].length > 0) {
                newBrands = state.brands[payload.brand.gender].filter(brand => brand.id !== payload.brand.id);
            }

            return {
                ...state,
                brands: {
                    ...state.brands,
                    [payload.brand.gender]: newBrands
                }
            };
        }

        case SET_BRAND_FAVORITES: {
            return { ...state, brands: action.payload };
        }

        case ADD_TO_FAVORITES_QUEUE: {
            if (!state.requestQueue) {
                return { ...state, requestQueue: [payload] };
            }

            if (!state.requestQueue.includes(payload)) {
                return { ...state, requestQueue: [...state.requestQueue, payload] };
            }

            return state;
        }

        case REMOVE_FROM_FAVORITES_QUEUE: {
            if (!state.requestQueue) {
                return { ...state, requestQueue: [] };
            }

            const variantIndex = state.requestQueue.findIndex(id => id === payload);

            if (variantIndex !== -1) {
                const requestQueue = [...state.requestQueue];
                requestQueue.splice(variantIndex, 1);
                return { ...state, requestQueue };
            }

            return state;
        }

        case DROP_FAVORITES: {
            return { ...state, products: [] };
        }

        case UPDATE_FAVORITES_VARIANTS_IDS: {
            const variantIds = state.products.map((product) => {
                const variantId = product.variant_id || product.variants[0].id;
                return Number(variantId);
            });
            return {
                ...state,
                variantIds
            };
        }

        case ADD_FAVORITE_VARIANT_ID: {
            const variantId = typeof payload === 'undefined' ? [] : Number(payload);
            return { ...state, variantIds: [variantId, ...state.variantIds] };
        }

        default:
            return state;
    }
}
